module.exports = __webpack_public_path__ + "static/media/Profile-photo-Martin.f76ee28b.jpg";